import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './components/not_found/not_found.component';
import { LoaderComponent } from './components/yi_loader/yi_loader.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule
  ],
  exports: [
    CommonModule,
    TranslateModule,
    LoaderComponent
  ],
  declarations: [
    PageNotFoundComponent,
    LoaderComponent
  ],
  providers: []
})
export class AppSharedModule {

  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: AppSharedModule
    };
  }
}
